module.exports = __webpack_public_path__ + "img/heraldsun.57c064bd.png";